import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { RowSummary } from '../../../SharedSC/DashboardSC';
import InstitutionIdTypeForm from '../../InstitutionIdTypeForm';
import { validateStringProperty } from '../../../../../helpers/validateGeneric';

const Layout = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: auto;
  background: ${props => props.theme.colors.white};
`;

const NewInstitutionIdType = ({
  className,
  newInstitutionIdType,
  allInstitutionIdTypes,
  showValidationErrors,
  handleChange,
  onPostCreate,
  clearNewForm,
  refProp
}) => (
  <Layout ref={refProp} className={className}>
    <RowSummary>
      <InstitutionIdTypeForm
        institutionIdType={newInstitutionIdType}
        entityLabel="Institution ID Type"
        buttonText="Create"
        showValidationErrors={showValidationErrors}
        validateName={() =>
          validateStringProperty(
            newInstitutionIdType.name,
            allInstitutionIdTypes,
            'name'
          )
        }
        handleChange={event => handleChange(event)}
        onSubmit={onPostCreate}
        onFormClose={clearNewForm}
      />
    </RowSummary>
  </Layout>
);

NewInstitutionIdType.propTypes = {
  newInstitutionIdType: PropTypes.object,
  allInstitutionIdTypes: PropTypes.arrayOf(PropTypes.object),
  showValidationErrors: PropTypes.bool,
  className: PropTypes.string,
  refProp: PropTypes.func,
  handleChange: PropTypes.func,
  onPostCreate: PropTypes.func,
  clearNewForm: PropTypes.func
};
NewInstitutionIdType.defaultProps = {
  newInstitutionIdType: {},
  allInstitutionIdTypes: [],
  showValidationErrors: false,
  className: '',
  refProp: undefined,
  handleChange: undefined,
  onPostCreate: undefined,
  clearNewForm: undefined
};

export default NewInstitutionIdType;
